import { lockScroll, unlockScroll } from './scrollBlocker';

export default function burgerMenu() {
    const burgerMenuOpenBtn = document.querySelector('.js-open-burger-menu');
    const burgerMenu = document.querySelector('.js-burger-menu');
    const burgerMenuCloseBtn = document.querySelector('.js-burger-menu-close');

    let burgerMenuOpen = false;

    if (burgerMenuOpenBtn && burgerMenu && burgerMenuCloseBtn) {
        const handleMenu = () => {
            if (!burgerMenuOpen) {
                lockScroll(burgerMenu);
                document.body.classList.add('burger-menu-shown');
                burgerMenuOpen = true;
            } else {
                unlockScroll();
                document.body.classList.remove('burger-menu-shown');
                burgerMenuOpen = false;
            }
        };

        burgerMenuOpenBtn.addEventListener('click', event => {
            event.preventDefault();
            handleMenu();
        });

        burgerMenuCloseBtn.addEventListener('click', event => {
            event.preventDefault();
            handleMenu();
        });

        document.addEventListener('click', event => {
            const insideMenu = event.target.matches('.js-burger-menu') || event.target.closest('.js-burger-menu');
            const insideOpenButton = event.target.matches('.js-open-burger-menu') || event.target.closest('.js-open-burger-menu');
            if (!insideMenu && !insideOpenButton) {
                if (burgerMenuOpen) {
                    unlockScroll();
                    document.body.classList.remove('burger-menu-shown');
                    burgerMenuOpen = false;
                }
            }
        });
    }
}
